import { render, staticRenderFns } from "./Informationrelease.vue?vue&type=template&id=624e352f&"
import script from "./Informationrelease.vue?vue&type=script&lang=js&"
export * from "./Informationrelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports